module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/103-marshall-island-0980e96b8a019de71bf634eae8504c39.svg";